<template>
  <div class="container">
    <points-config-automatic-points-title />
    <points-config-intros-config-table class="m-tx4" />
  </div>
</template>
